"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._ParquetInput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=_ParquetInput.js.map